export default "__VITE_ASSET__ClA$LOsA__"